var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ChangeEventListener } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
class ThemeSelectorAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        /** @event */
        this.onChange = new ChangeEventListener();
    }
    /**
     * Returns the accent color expression.
     */
    getAccentColorsExpression() {
        return this.state.accentColorsExpression;
    }
    /**
     * Sets the accent color expression.
     *
     * @param accentColorsExpression - The accent color expression.
     */
    setAccentColorsExpression(accentColorsExpression) {
        this.setState({ accentColorsExpression });
    }
    /**
     * Returns the colors expression.
     */
    getColorsExpression() {
        return this.state.colorsExpression;
    }
    /**
     * Sets the colors expression.
     *
     * @param colorsExpression - The colors expression.
     */
    setColorsExpression(colorsExpression) {
        this.setState({ colorsExpression });
    }
    /**
     * Returns the content tone expression.
     */
    getContentToneExpression() {
        return this.state.contentToneExpression;
    }
    /**
     * Sets the content tone expression.
     *
     * @param contentToneExpression - The content tone expression.
     */
    setContentToneExpression(contentToneExpression) {
        this.setState({ contentToneExpression });
    }
    /**
     * Returns the default color.
     */
    getDefaultColor() {
        return this.state.defaultColor;
    }
    /**
     * Sets the default color.
     *
     * @param defaultColor - The default color.
     */
    setDefaultColor(defaultColor) {
        this.setState({ defaultColor });
    }
    /**
     * Returns if the text editor is enabled.
     */
    isEnabled() {
        return this.state.enabled;
    }
    /**
     * Sets if the text editor is enabled.
     *
     * @param enabled - If the text editor is enabled.
     */
    setEnabled(enabled) {
        this.setState({ enabled });
    }
    /**
     * Returns the hidden accent colors.
     */
    geHiddenAccentColors() {
        return this.state.hiddenAccentColors;
    }
    /**
     * Sets the hidden accent colors.
     *
     * @param hiddenAccentColors - The hidden accent colors.
     */
    setHiddenAccentColors(hiddenAccentColors) {
        this.setState({ hiddenAccentColors });
    }
    /**
     * Returns the hidden colors.
     */
    geHiddenColors() {
        return this.state.hiddenColors;
    }
    /**
     * Sets the hidden colors.
     *
     * @param hiddenColors - The hidden colors.
     */
    setHiddenColors(hiddenColors) {
        this.setState({ hiddenColors });
    }
    /**
     * Returns the hidden content tonal ranges.
     */
    geHiddenContentTotalRanges() {
        return this.state.hiddenContentTotalRanges;
    }
    /**
     * Sets the hidden content tonal ranges.
     *
     * @param hiddenContentTotalRanges - The hidden content tonal ranges.
     */
    setHiddenContentTotalRanges(hiddenContentTotalRanges) {
        this.setState({ hiddenContentTotalRanges });
    }
    /**
     * Returns the hidden navigation tonal ranges.
     */
    geHiddenNavigationTotalRanges() {
        return this.state.hiddenNavigationTotalRanges;
    }
    /**
     * Sets the hidden navigation tonal ranges.
     *
     * @param hiddenNavigationTotalRanges - The hidden navigation tonal ranges.
     */
    setHiddenNavigationTotalRanges(hiddenNavigationTotalRanges) {
        this.setState({ hiddenNavigationTotalRanges });
    }
    /**
     * Returns the navigation tone expression.
     */
    getNavigationToneExpression() {
        return this.state.navigationToneExpression;
    }
    /**
     * Sets the navigation tone expression.
     *
     * @param navigationToneExpression - The navigation tone expression.
     */
    setNavigationToneExpression(navigationToneExpression) {
        this.setState({ navigationToneExpression });
    }
    /**
     * Returns if theme selector is showing the accent color.
     */
    getShowAccentColor() {
        return this.state.showAccentColor;
    }
    /**
     * Sets if theme selector is showing the accent color.
     *
     * @param showAccentColor - if theme selector is showing the accent color.
     */
    setShowAccentColor(showAccentColor) {
        this.setState({ showAccentColor });
    }
    /**
     * Returns if theme selector is showing the color.
     */
    getShowColor() {
        return this.state.showColor;
    }
    /**
     * Sets if theme selector is showing the color.
     *
     * @param showColor - if theme selector is showing the color.
     */
    setShowColor(showColor) {
        this.setState({ showColor });
    }
    /**
     * Returns if theme selector is showing the content tonal range.
     */
    getShowContentTonalRange() {
        return this.state.showContentTonalRange;
    }
    /**
     * Sets if theme selector is showing the content tonal range.
     *
     * @param showContentTonalRange - if theme selector is showing the content tonal range.
     */
    setShowContentTonalRange(showContentTonalRange) {
        this.setState({ showContentTonalRange });
    }
    /**
     * Returns if theme selector is showing the navigation tonal range.
     */
    getShowNavigationTonalRange() {
        return this.state.showNavigationTonalRange;
    }
    /**
     * Sets if theme selector is showing the navigation tonal range.
     *
     * @param showNavigationTonalRange - if theme selector is showing the navigation tonal range.
     */
    setShowNavigationTonalRange(showNavigationTonalRange) {
        this.setState({ showNavigationTonalRange });
    }
    /**
     * Returns the value.
     */
    getValue() {
        return this.state.value;
    }
    /**
     * Sets the value.
     *
     * @param navigationToneExpression - The value.
     */
    setValue(value) {
        this.setState({ value });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], ThemeSelectorAPI.prototype, "onChange", void 0);
export { ThemeSelectorAPI, };
//# sourceMappingURL=theme-selector-api.js.map